import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  notification: {
    margin: 0,
    boxShadow: 'none',
    alignItems: 'flex-start',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px'
  }
});

export default makeStyles(styles);
